import { mainColor, UNIT } from '../../constants/theme';

export const styles = theme => ({
  root: {
    width: '100%',
    marginTop: UNIT
  },
  panel: {
    height: UNIT * 4.125
  },
  paperStyle: { marginTop: '0px', padding: UNIT * 1.25, width: '100%' },
  addIcon: { marginRight: UNIT * 0.375 },
  titleText: { fontSize: UNIT * 1.125, alignSelf: 'center' },
  rootFees: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorBlack,
    backgroundColor: 'transparent',
    align: 'center'
  },
  iconStyle: {
    width: UNIT * 1.5,
    height: UNIT * 1.5,
    align: 'center',
    color: mainColor.colorWhite,
    backgroundColor: mainColor.secondaryColor
  },
  arroundIcon: {
    backgroundColor: 'white',
    margin: 5,
    marginLeft: 0,
    padding: UNIT * 0.5,
    borderRadius: UNIT * 0.625
  },
  listItemStyle: {
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px'
  },
  removeIcon: { width: UNIT, height: UNIT },
  form: { display: 'flex', flexDirection: 'row' },
  form2: { width: '43%', minWidth: UNIT * 6.25 },
  details: { paddingLeft: UNIT * 3.125, paddingRight: UNIT * 3.125, paddingTop: UNIT * 0.625 },
  expansioPanel: { height: 'fit-content', width: '100%' },
  formControl: { width: '43%', minWidth: UNIT * 6.25, padding: '0 10px 0 10px' },
  cancelItem: {
    padding: UNIT * 0.5,
    display: 'flex',
    marginTop: 'auto',
    marginBottom: 'auto',
    fontSize: UNIT * 0.8125
  },
  subZone: {
    backgroundColor: 'rgba(200, 200, 200, 0.3)'
  },
  dataZone: { display: 'flex', width: '100%' },
  panelDetail: { backgroundColor: mainColor.colorWhite },
  radio: {
    '&$checked': {
      color: mainColor.secondaryColor
    }
  },
  checked: {},
  zonePosition: {
    width: UNIT * 2.5,
    display: 'flex',
    borderRadius: UNIT * 1.25,
    color: mainColor.colorWhite,
    alignItems: 'center',
    justifyContent: 'center',
    height: UNIT * 2.5,
    opacity: 0.7
  },
  headerFee: {
    fontWeight: 'normal',
    fontSize: UNIT * 0.8125,
    color: mainColor.colorBlack
  }
});
